import { ID } from '@datorama/akita';

export const FLOWINC_DOT_COM = 'https://flowinc.com';
export const GLOBAL_ORG_ID: ID = '00000000-0000-0000-0000-000000000000';
export const PRIVACY_POLICY_URL = 'https://flowinc.com/privacy-policy';
export const TERMS_OF_USE_URL = 'https://flowinc.com/terms-of-use';
export const USER_OWN_ID: ID = '11111111-1111-1111-1111-111111111111';
